module.exports = __webpack_public_path__ + "static/media/unplugging_48.26a165da.png";